export const galleryFunc = () => {
  /**
   * ギャラリーのモーダル
   */
  {
    const html = `<div class="p-gallery-modal js-gallery-modal">
      <div class="p-gallery-modal__content js-gallery-modal__content"></div>
      <button class="p-gallery-modal__close js-gallery-modal__close"></button>
    </div><!-- /.p-gallery-modal -->`;

    document.body.insertAdjacentHTML('beforeend', html);

    const $openArr = [...document.querySelectorAll('.js-gallery-modal__open')];
    const $modal = document.querySelector('.js-gallery-modal');
    const $content = $modal.querySelector('.js-gallery-modal__content');
    const $close = $modal.querySelector('.js-gallery-modal__close');

    $openArr.forEach($open => {
      const src = $open.dataset.src;
      const tag = src.includes('youtube') ? 'iframe' : 'img';

      $open.addEventListener('click', () => {
        $content.innerHTML = `<${tag} src="${src}">`;
        $modal.classList.add('is--active');
      });
    });

    $close.addEventListener('click', () => {
      $modal.classList.remove('is--active');
    });

    $modal.addEventListener('transitionend', () => {
      if ($modal.classList.contains('is--active')) return;
      $content.replaceChildren();
    });
  }
};
